/** The idle tournament card (unit convention §1) — see `model.ts` (G5). */
import React from 'react';

import {useTournamentIdleModel} from './model';
import TournamentIdleView from './View';

export default React.memo(function TournamentIdle() {
  return <TournamentIdleView {...useTournamentIdleModel()} />;
});
